import React from 'react';
import Pill from '../../design-system/primitives/Pill';
import Btn from '../../design-system/primitives/Btn';
import Icon from '../../design-system/primitives/Icon';
import { fmtDate, relTime } from './format';

const CADENCE_LABEL = { monthly: 'Monthly limits', yearly: 'Yearly limits', one_off: 'One-off grant' };

// The Django admin is served by the API host, not the SPA (which on the dev
// server is a different origin), so admin links are absolute.
const API_ORIGIN = (process.env.REACT_APP_API_URL || 'http://localhost:8000/api').replace(/\/api\/?$/, '');

const EntityHeader = ({ entity, limits, activity, onSelect }) => {
  const isUser = entity.type === 'user';
  const subtitle = isUser
    ? [entity.email, entity.organization?.name].filter(Boolean).join(' · ')
    : [entity.industry, entity.country, entity.num_employees].filter(Boolean).join(' · ');

  return (
    <div className="qa-head">
      <div className="qa-head__id">
        <span className="qa-head__icon"><Icon name={isUser ? 'user' : 'building-2'} size={18} /></span>
        <div>
          <h1 className="qa-head__title">{entity.name}</h1>
          <div className="qa-head__sub">
            {subtitle}
            {isUser && entity.organization && (
              <button type="button" className="qa-link" onClick={() => onSelect({ type: 'org', id: entity.organization.id })}>
                open organization page
              </button>
            )}
          </div>
        </div>
      </div>
      <div className="qa-head__pills">
        {limits.production_api_enabled
          ? <Pill tone="green" dot>Production API</Pill>
          : <Pill tone="outline">No production API</Pill>}
        {limits.is_unlimited
          ? <Pill tone="accent">Unlimited</Pill>
          : limits.cadence
            ? <Pill tone="neutral">{CADENCE_LABEL[limits.cadence]}{limits.cadence !== 'one_off' && limits.period_start ? ` · since ${fmtDate(limits.period_start)}` : ''}</Pill>
            : <Pill tone="outline">{limits.scope === 'staff' ? 'Staff · unlimited' : 'No limits row · unlimited by default'}</Pill>}
        {limits.scope === 'organization' && isUser && limits.source && (
          <Pill tone="neutral" icon="building-2">Limits from {limits.source.name}</Pill>
        )}
        {limits.both_owners_set && (
          <Pill tone="outline" icon="alert-triangle" style={{ color: 'var(--danger)', borderColor: 'color-mix(in srgb, var(--danger) 40%, transparent)' }}>
            Limits row names both a user and the organization: only {limits.source?.name}'s usage counts
          </Pill>
        )}
        {entity.is_staff && <Pill tone="accent-strong">Staff</Pill>}
        {entity.is_primary_contact && <Pill tone="outline">Primary contact</Pill>}
        {limits.remaining_access_days != null && (
          <Pill tone={limits.remaining_access_days === 0 ? 'outline' : 'neutral'}>{limits.remaining_access_days} access days left</Pill>
        )}
        <Btn size="xs" kind="ghost" icon="external-link" onClick={() => window.open(`${API_ORIGIN}${limits.admin_url}`, '_blank', 'noopener')}>
          {limits.source ? 'Edit limits' : 'Grant limits'}
        </Btn>
      </div>
      <div className="qa-head__activity">
        <span><b>Last login</b> {relTime(activity.last_login)}</span>
        <span><b>Last web activity</b> {relTime(activity.last_web_activity)}</span>
        <span><b>Last API activity</b> {relTime(activity.last_api_activity)}</span>
        <span><b>{isUser ? 'Joined' : 'First member joined'}</b> {fmtDate(activity.date_joined)}</span>
      </div>
    </div>
  );
};

export default EntityHeader;
